import { COLORS } from '@app/constants';
import styled from 'styled-components';
import { media } from '@/styles/Qtheme.ts';
import { MobileCalVW, TabletCalVW } from '@utils/CalVW.tsx';

export const AuditSettingSection = styled.div`
  width: 1200px;

  @media ${media.desktop} {
    width: ${TabletCalVW(900)};
  }
`;

export const AuditSettingContainer = styled.div`
  display: flex;
  border-radius: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: 20px;
  width: 100%;
  height: 300px;
  background-color: ${({ theme }) => theme.body};
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 50px;

  @media ${media.desktop} {
    gap: 10px;
  }

  @media ${media.mobile} {
    gap: ${MobileCalVW(12)};
    flex-direction: column;
    height: auto;
  }

  //@media only screen and (max-width: 900px) {
  //    flex-direction: column-reverse;
  //    height: 1200px;
  //}
`;
export const IdentifyVerificationSection = styled.div`
  width: 48%;
  height: 100%;
  border-radius: 15px;
  background-color: ${({ theme }) => theme.COLORS.PrimaryBg};
  border: 1px solid ${({ theme }) => theme.COLORS.PrimaryBorder};
  padding-top: 30px;

  @media ${media.desktop} {
    width: 100%;
    padding-top: 24px;
    margin-top: 12px;
  }

  @media ${media.mobile} {
    padding: ${MobileCalVW(24)} 0;
  }
`;

export const ProfileTradingViewAlertSection = styled.div`
  width: 100%;
  height: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-block: 24px;
  padding-inline: 32px;
  border-radius: 15px;
  background-color: ${COLORS.white};
`;
export const ProfileTradingAlertHeaderSection = styled.div`
  height: 76px;
  width: 100%;
  padding-block: 24px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;
